import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'utils/helpers';
import Accordion from 'components/common/controls/Accordion';

const propTypes = {
  title: PropTypes.any,
  info: PropTypes.any,
};

const ThankYouItem = (props) => {
  const { title, info } = props;
  if (isMobile) {
    return (
      <div className="thank-you__section">
        <Accordion title={title}>
          <div className="thank-you__section-content">
            {info}
          </div>
        </Accordion>
      </div>
    );
  }
  return (
    <div className="thank-you__section">
      <span className="thank-you__section-title">
        {title}
      </span>
      <div className="thank-you__section-content">
        {info}
      </div>
    </div>
  );
};

ThankYouItem.propTypes = propTypes;

export default ThankYouItem;
